import { toast } from "sonner";

// Safe copy — some contexts (denied permission, unfocused tab, older mobile browsers) make
// navigator.clipboard.writeText throw. Unhandled, that popped a CRA error overlay that froze the
// whole page. This guards it and falls back to a hidden textarea + execCommand.
export async function copyText(text, successMsg = "Copied") {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
    } else {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    if (successMsg) toast.success(successMsg);
    return true;
  } catch {
    toast.error("Couldn't copy automatically — select the link and copy it manually");
    return false;
  }
}
